import { cn } from 'src/lib/utils';
import { Badge } from '@/components/ui/badge';
import { productTypeMap } from 'src/shared/mappings/productTypeMap';

import { useAppCard, type UnclaimedDetectedProduct } from '../model';

const DetectedProductItem = ({ product }: { product: UnclaimedDetectedProduct }) => {
  const { icon: Icon, label } = productTypeMap[product.productType];

  return (
    <div className="flex items-start justify-between gap-2">
      <div className="space-y-1 min-w-0">
        <div className="font-bold text-sm truncate">{product.name}</div>
        <div className="flex items-center gap-1.5">
          <Icon className="size-4" />
          <span className="text-xs text-muted-foreground font-semibold">{label}</span>
        </div>
      </div>
      <Badge
        className={cn(
          'rounded-full px-2.5 py-0.5 text-xs font-semibold shrink-0 h-6',
          product.status.bgColor,
          product.status.color,
        )}
      >
        {product.status.label}
      </Badge>
    </div>
  );
};

const DetectedProductRow = () => {
  const { data } = useAppCard();

  if (data.unclaimedDetectedProduct.length === 0) return null;

  return (
    <div className="space-y-1">
      {data.unclaimedDetectedProduct.map((product, index) => (
        <DetectedProductItem key={`${product.productType}-${index}`} product={product} />
      ))}
    </div>
  );
};

export { DetectedProductRow };
